import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { deepCopy, diffObject, removeUndefined } from 'diwimamodelweb/lib/utils/obejct-diff';
import { EventsService } from '../events.service';
import { GenericDialogComponent } from '../generic-dialog/generic-dialog.component';
import { HuntingEventForm } from '../model/form';
import { UserFeedbackService } from '../user-feedback.service';


@Component({
  selector: 'app-hunting-event-form',
  templateUrl: './hunting-event-form.component.html',
  styleUrls: ['./hunting-event-form.component.css', '../../app.component.scss']
})
export class HuntingEventFormComponent implements OnInit {

  @Input() data: HuntingEventForm
  @Input() formBuilder: FormBuilder
  @Input() userFeedbackService: UserFeedbackService
  @Input() objectService: EventsService
  @Input() translateService: TranslateService

  submitted = false
  isCreate = false
  isNewEvent = false
  eventForm: FormGroup
  oldEvent: any

  constructor() { }

  ngOnInit(): void {
    if (!this.data.data){
       this.isCreate = true
       this.isNewEvent = true
    }
    else this.oldEvent = deepCopy(this.data.data)
    this.eventForm = this.formBuilder.group({
      name: [, Validators.required],
      date: [],
      active: [],
      comment: [],
      huntingDistrict: []
    })
    if (this.data.data){
      this.initializeData()
      this.isNewEvent = false
    } 
    this.eventForm.valueChanges.subscribe((value) => {
      const {name, date, active, comment, huntingDistrict} = value
      if (!this.isCreate) {
        name ? this.data.data.name = name : null
        date ? this.data.data.date = date : null
        this.data.data.active = !active ? false : true
        comment ? this.data.data.comment = comment : null
        if (huntingDistrict) {
          this.data.data.huntingDistrictId = huntingDistrict.identifier
          this.data.data.huntingDistrictName = huntingDistrict.name
        }
      } else {}
    })
    this.data.onNavBack = this.onCancle
  }

  initializeData() {
    const {name, date, active, comment, huntingDistrictId } = this.data.data
    const district = this.data.huntingDistricts?.find(el => el.identifier == huntingDistrictId)
    this.eventForm.patchValue({
      comment, name, date, active, huntingDistrict: district 
    })
  }

  async onSubmit() {
    const {comment, name, date, active, huntingDistrict} = this.eventForm.value
    if (this.isCreate) {
      // create new event...
      let event = {
        comment:comment? comment : undefined, 
        name, 
        date: date ? date: undefined, 
        active: active ? active : undefined, 
        huntingDistrictId: huntingDistrict?.identifier, 
        huntingDistrictName: huntingDistrict?.name}
      const cleaned = removeUndefined(event)
      try {
        this.userFeedbackService.loading.emit(true)
        await this.objectService.createEvent(cleaned)
        this.userFeedbackService.loading.emit(false)
        const sbSuccessSave = await this.translateService.get('successfully_created').toPromise()
        this.userFeedbackService.showSnackBar.emit(sbSuccessSave)
        this.data.onSuccessfullySubmitted()
      } catch (error) {
        this.userFeedbackService.loading.emit(false)
        console.log(error)
        this.userFeedbackService.showDialog.emit(
          {
            entryComponent: GenericDialogComponent,
            title: "Error",
            message: error.error.message ? error.error.message : JSON.stringify(error),
          }
        )
      }
    } else {
      try {

        ///-----------------------------------
        //update have errors
        this.userFeedbackService.loading.emit(true)
        await this.objectService.updateExistingEvent(this.oldEvent, this.data.data)
        this.userFeedbackService.loading.emit(false)
        const sbSuccessSave = await this.translateService.get('changes_saved').toPromise()
        this.userFeedbackService.showSnackBar.emit(sbSuccessSave)
        this.data.onSuccessfullySubmitted()
      } catch (error) {
        this.userFeedbackService.loading.emit(false)
        this.userFeedbackService.showDialog.emit(
          {
            entryComponent: GenericDialogComponent,
            title: "Error",
            message: error?.error?.message ? error?.error?.message : JSON.stringify(error),
          }
        )
      }
    }
  }

  onCancle = async () => {
    if (this.isCreate) {
      // if it is a new event
      
      const title = await this.translateService.get('title_unsaved_changes').toPromise()
      const message = await this.translateService.get('msg_unsaved_changes').toPromise()
      this.userFeedbackService.showDialog.emit(
        {
          entryComponent: GenericDialogComponent,
          title,
          message,
          cancleCallback: async () => {
            const sbChangesDismissed = await this.translateService.get('changes_dismissed').toPromise()
            this.userFeedbackService.showSnackBar.emit(sbChangesDismissed)
            this.data.onCancle()
          },
          positiveCallback: async ()=> {
            await this.onSubmit()
            this.data.onSuccessfullySubmitted()
          }
        }
      )
    } else {
      const diff = diffObject(this.oldEvent, this.data.data, {})
      if (Object.keys(diff).length == 0) this.data.onCancle()
      else {
        const title = await this.translateService.get('title_unsaved_changes').toPromise()
        const message = await this.translateService.get('msg_unsaved_changes').toPromise()
        this.userFeedbackService.showDialog.emit(
          {
            entryComponent: GenericDialogComponent,
            title,
            message,
            cancleCallback: async () => {
              const sbChangesDismissed = await this.translateService.get('changes_dismissed').toPromise()
              this.userFeedbackService.showSnackBar.emit(sbChangesDismissed)
              this.data.onCancle()
            },
            positiveCallback: async ()=> {

              /////----------------------------
              await this.onSubmit()
            }
          }
        )
      }
    }
  }


  async onDelete(){
    

    if(!this.isNewEvent){
      const title = await this.translateService.get('delete_title').toPromise()
      const message = await this.translateService.get('delete_message').toPromise()  
      this.userFeedbackService.loading.emit(false)
      this.userFeedbackService.showDialog.emit({
        entryComponent: GenericDialogComponent,
        title,
        message,
        cancleCallback: async()=> {
          const sbCancelDelete = await this.translateService.get('delete_canceled').toPromise() 
          this.userFeedbackService.showSnackBar.emit(sbCancelDelete)
        },
        positiveCallback: async()=> {
          try{
            this.userFeedbackService.loading.emit(true)
              const sbSuccessDelete = await this.translateService.get('delete_completed').toPromise() 
              await this.objectService.deleteHuntingEvent(this.data.data)
              this.userFeedbackService.loading.emit(false)
              this.userFeedbackService.showSnackBar.emit(sbSuccessDelete)
              this.data.onCancle()
          }catch(errorDelete){

          }
          
        }
      })
    }else{
      this.userFeedbackService.loading.emit(true)
      const sbSNoDelete = await this.translateService.get('delete_not_possible').toPromise() 
      this.userFeedbackService.showSnackBar.emit(sbSNoDelete) 
    }
  }
}
